// extracted by css-extract-rspack-plugin
export default {"label":"InfoItem-module__label__dLDJG","wrapper":"InfoItem-module__wrapper__DV_cl","isInline":"InfoItem-module__isInline__wF1x6"};